// general
export const SET_LOADING = "setLoading";
export const SET_LOADING_LOGS = "setLoadingLogs";
export const SHOW_DIALOG = "showDialog";
export const HIDE_DIALOG = "hideDialog";
export const MUTATE_SNACK = "setSnack";
export const SET_DISPLAY_ADVANCED_SEARCH = "setDisplayAdvancedSearch";
export const SET_DETAIL_VIEW_BACK_LINK = "setDetailViewBackLink";
export const SET_HEADER_REVEAL = "setHeaderReveal";

// user
export const SET_USER = "setUser";
export const SET_COMPANY_USERS = "setCompanyUsers";

// species
export const SET_ALL_SPECIES = "setAllSpecies";
export const SET_GALLERY_VIEW = "setGalleryView";
export const SET_GALLERY_SORTING = "setGallerySorting";
export const SET_GALLERY_SORTING_DIRECTION = "setGallerySortingDirection";
// species filter
export const SET_SPECIES_FILTER_LIST = "setSpeciesFilterList";
export const SET_FILTER_PARAMS = "setFilterParams";
export const SET_FILTER_COLOR = "setFilterColor";
export const SET_FILTER_APPLICATION = "setFilterApplication";
export const SET_FILTER_OCCURRENCE = "setFilterOccurrence";
export const SET_FILTER_AVAILABILITY = "setFilterAvailability";
export const SET_FILTER_PRICEGROUP = "setFilterPricegroup";
export const SET_FILTER_FSC = "setFilterFsc";
export const SET_FILTER_PEFC = "setFilterPefc";

// search
export const SET_SEARCH_TYPE = "setSearchType";
export const SET_SEARCH_DISPLAY_TYPE = "setSearchDisplayType";
export const SET_SEARCH_DISPLAY_TYPE_PALLET = "setSearchDisplayTypePallet";
export const SET_PALLET_LOGS_SEARCH_DISPLAY_TYPE = "setPalletLogsSearchDisplayType";
export const SET_SEARCH_PARAMS = "setSearchParams";
export const RESET_SEARCH_PARAMS = "resetSearchParams";
export const SET_SEARCH_RESULTS = "setSearchResults";
export const RESET_SEARCH_RESULTS = "resetSearchResults";
export const SET_SEARCH_FILTER_DATA = "setSearchFilterData";
export const SET_SEARCH_RESULTS_EXHAUSTED = "setSearchResultsExhausted";
export const SET_SEARCH_REQUEST = "setSearchRequest";

// watchlist
export const SET_WATCHLIST_SEARCH_PARAMS = "setWatchlistSearchParams";
export const SET_OBJECT_TO_ADD = "setObjectToAdd";
export const SET_WATCHLISTS = "setWatchlists";
export const SET_WATCHLISTS_FILTER = "setWatchlistsFilter";
export const SET_WATCHLISTS_PAGINATION = "setWatchlistsPagination";
export const ADD_WATCHLIST = "addWatchlist";
export const SET_WATCHLIST = "setWatchlist";
export const SET_WATCHLIST_ITEM = "setWatchlistItem";
export const REPLACE_WATCHLIST = "replaceWatchlist";
export const REMOVE_WATCHLIST = "removeWatchlist";
export const REMOVE_ITEM = "removeItem";
export const REPLACE_WATCHLIST_ITEM = "replaceWatchlistItem";
export const UPDATE_VIRTUAL_LOG_ON_WATCHLIST = "updateVirtualLogOnWatchlist";
export const SET_EDIT_SEARCH_PARAMS = "setEditSearchParams";

// log
export const SET_DETAIL_ITEM = "setDetailItem";
export const SET_BUNDLES = "setBundles";

// pallet
export const SET_PALLET_LOGS = "setPalletLogs";

// virtual log
export const SET_VIRTUAL_LOG = "setVirtualLog";
export const SET_VIRTUAL_LOG_UID = "setVirtualLogUid";
export const START_VIRTUAL_LOG_CREATION = "startVirtualLogCreation";
export const ADD_TO_VIRTUAL_LOG = "addToVirtualLog";
export const REMOVE_FROM_VIRTUAL_LOG = "removeFromVirtualLog";
export const SET_BUNDLES_FOR_VIRTUAL_LOG = "setBundlesForVirtualLog";
export const ADD_BUNDLE_TO_VIRTUAL_LOG = "addBundleToVirtualLog";
export const REMOVE_BUNDLE_FROM_VIRTUAL_LOG = "removeBundleToVirtualLog";
export const MOVE_BUNDLE_TO_INDEX_IN_VIRTUAL_LOG = "moveBundleToIndexInVirtualLog";
export const UPDATE_CALCULATED_VIRTUAL_LOG_VALUES = "updateCalculatedVirtualLogValues";
export const RESET_BUNDLE_NUMBERS = "resetBundleNumbers";
export const SET_VIRTUAL_LOG_TEASER = "setVirtualLogTeaser";
export const SET_VIRTUAL_LOG_PROPS = "setVirtualLogProps";
export const REMOVED_VIRTUAL_LOG_FROM_WATCHLIST = "removedVirtualLogFromWatchlist";
export const SET_VIRTUAL_LOG_WATCHLIST_ITEM = "setVirtualLogWatchlistItem";
export const SET_VIRTUAL_LOG_EDIT_MODE = "setVirtualLogEditMode";